import React from "react";
import { useLocation } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

const Footer = () => {
  const location = useLocation();
  const isContactPage = location.pathname === "/contact";

  return (
    <>
      {!isContactPage && (
        <div
          className="connect-section py-5"
          style={{
            background: "#080C3D",
          }}
        >
          <Container>
            <Row
              className="justify-content-between"
              style={{ flexWrap: "inherit" }}
            >
              <Col md={4} lg={5}>
                <h2 className="mb-4 text-white">Connect With Us</h2>
                <div className="mb-4">
                  <a
                    href="mailto:info@fyled.ai"
                    className="text-white text-decoration-underline"
                  >
                    info@fyled.ai
                  </a>
                </div>

                <div className="mb-5">
                  <a
                    href="https://www.linkedin.com/company/fyled-ai"
                    className="me-4 social-icon"
                    aria-label="LinkedIn"
                  >
                    <i className="bi bi-linkedin text-white fs-4"></i>
                  </a>
                  <a
                    href="https://twitter.com/fyled"
                    className="social-icon"
                    aria-label="Twitter"
                  >
                    <i className="bi bi-twitter-x text-white fs-4"></i>
                  </a>
                </div>
              </Col>
              <Col md={4} lg={5}>
                <div className="platform-section mb-4">
                  <h4 className="text-uppercase text-white-50 mb-4">
                    Services
                  </h4>
                  <ul className="list-unstyled">
                    <li className="mb-3">
                      <a
                        href="#/fto-report"
                        className="text-white text-decoration-none"
                      >
                        FTO Report
                      </a>
                    </li>
                    <li className="mb-3">
                      <a
                        href="#/prior-art-report"
                        className="text-white text-decoration-none"
                      >
                        Prior Art Report
                      </a>
                    </li>
                    <li className="mb-3">
                      <a
                        href="#/validity-search"
                        className="text-white text-decoration-none"
                      >
                        Validity Search
                      </a>
                    </li>
                    <li className="mb-3">
                      <a
                        href="#/compound-intelligence"
                        className="text-white text-decoration-none"
                      >
                        Compound Intelligence
                      </a>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col md={4} lg={5}>
                <div className="pages-section">
                  <h4 className="text-uppercase text-white-50 mb-4">Pages</h4>
                  <ul className="list-unstyled">
                    <li className="mb-3">
                      <a href="/" className="text-white text-decoration-none">
                        Company
                      </a>
                    </li>
                    <li className="mb-3">
                      <a href="/" className="text-white text-decoration-none">
                        Security
                      </a>
                    </li>
                    <li className="mb-3">
                      <a href="#/news" className="text-white text-decoration-none">
                        News
                      </a>
                    </li>
                    <li className="mb-3">
                      <a href="/" className="text-white text-decoration-none">
                        Careers
                      </a>
                    </li>
                    <li className="mb-3">
                      <a
                        href="/docs/Customer_agreement.pdf"
                        className="text-white text-decoration-none"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Customer Agreement
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="copyright-section mt-5 pt-5">
                  <p className="text-white-50">
                    © {new Date().getFullYear()} FYLED AI
                  </p>
                  <p className="text-white-50">
                    9110 Alcosta Blvd, Ste H #3021
                    <br />
                    San Ramon, CA 94583
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}
      <div className="text-center py-4 bg-light">
        <p>© {new Date().getFullYear()} Fyled AI. All rights reserved.</p>
      </div>
    </>
  );
};

export default Footer;
